const redirectToCourseSection = (shortCourseId) => {
  const url = `/courses/${encodeURIComponent(shortCourseId)}/mycourse`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export { redirectToCourseSection };
